export const load = () => ({
  bodyClass: "landing",
});
